import { useFieldArray, useFormContext } from 'react-hook-form';
import { BoolRadioField } from '@views/register/history/history-fields';
import type { TLocalize } from '@hooks/use-localize';
import type { IHistoryMiscFormValues } from '@/types/history/history-misc';
import FieldError from '@components/field-error';

interface IProps {
    t: TLocalize;
}

const SurgeriesSection = ({ t }: IProps) => {
    const {
        control,
        register,
        watch,
        formState: { errors },
    } = useFormContext<IHistoryMiscFormValues>();
    const { fields, append, remove } = useFieldArray({ control, name: 'surgeries' });

    const surgery = t('DashWord_Surgery', 'Surgery');
    const when = t('DashWord_When', 'When');
    const deleteSurgery = t('DashLabel_DeleteSurgery', 'Delete surgery');

    return (
        <>
            <BoolRadioField
                name="hasHadSurgeries"
                label={t('DashLabel_HaveYouHadAnySurgeriesOperationsInThePast', 'Have you had any surgeries/operations in the past')}
                yesLabel={t('Word_Yes', 'Yes')}
                noLabel={t('Word_No', 'No')}
            />

            {watch('hasHadSurgeries') === '1' && (
                <div className="sub-question">
                    <div className="form-group">
                        <div className="col-xs-12">
                            <div className="help-block">
                                {t('DashLabel_PleaseListYourSurgeriesAndAnApproximateDetailOfWhen', 'Please list your surgeries and an approximate detail of when')}
                                <FieldError message={errors.surgeries?.root?.message ?? errors.surgeries?.message} />
                            </div>

                            <div className="row hidden-xs">
                                <div className="col-sm-5">{surgery}</div>
                                <div className="col-sm-4">{when}</div>
                            </div>

                            {fields.map((field, index) => (
                                <div className="row row-margined" key={field.id}>
                                    <div className="col-xs-12 col-sm-5">
                                        <input
                                            className="form-control"
                                            placeholder={surgery}
                                            {...register(`surgeries.${index}.name`)}
                                        />
                                    </div>
                                    <div className="col-xs-12 col-sm-4">
                                        <input
                                            className="form-control"
                                            placeholder={when}
                                            {...register(`surgeries.${index}.when`)}
                                        />
                                    </div>
                                    <div className="col-xs-12 col-sm-1">
                                        {index > 0 && (
                                            <button
                                                type="button"
                                                className="btn btn-danger"
                                                aria-label={deleteSurgery}
                                                title={deleteSurgery}
                                                onClick={() => remove(index)}
                                            >
                                                <span className="glyphicon glyphicon-trash" aria-hidden="true"></span>
                                            </button>
                                        )}
                                    </div>
                                    <div className="visible-xs">&nbsp;</div>
                                </div>
                            ))}

                            <div className="row">
                                <div className="col-xs-12">
                                    <button
                                        type="button"
                                        className="btn btn-add-entry btn-sm"
                                        style={{ width: 150 }}
                                        onClick={() => append({ name: '', when: '' })}
                                    >
                                        <span className="glyphicon glyphicon-plus-sign"></span>{' '}
                                        {t('DashLabel_AddSurgery', 'Add Surgery')}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default SurgeriesSection;
